module.exports = __webpack_public_path__ + "img/taiko.e3679e39.jpg";